import React, {  useState,useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { Card, Modal, Row, Col, Empty,Input } from 'antd';
import { ExclamationCircleOutlined,SearchOutlined } from '@ant-design/icons';
import {getTemplatePageDraftList,deleteTemplatePageDraft,setAddEditPages,showLoading,hideLoading,updateTemplatePageDraft} from "redux/actions/templatePage"
import { debounce } from 'lodash';
import { useTranslation } from "react-i18next";
import GridLoader from 'components/util-components/GridLoader';
import ListGridView from './list-grid-page';
import AddTemplatePageDraft from '../../add-template-page-draft';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig';
import { PATH_VARIABLE } from 'constants/ApiConstant';

const TemplatePageList=(props)=> {
   const { templatePagesDrafts,getTemplatePageDraftList,deleteTemplatePageDraft,updateTemplatePageDraft,setAddEditPages,showLoading,hideLoading,selectedTemplate,selectedTab,addEditPagesValue,switchTabs } = props;
   const [query, setQuery] = useState(undefined);
   const [loader,setLoader]=useState(false);
   const { t } = useTranslation();
   const [pagination, setPagination] =useState({current:1,pageSize:10});
   const hasFetched = useRef(false);
   const { param } = props;
   const { id } = param;
   const appId = id;
   const templateId = localStorage.getItem("templateId");
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [replacedHTML] = useState();

   useEffect(() => {
  
	async function fetchData() {
	  if (hasFetched.current) return; // Prevents the second call
	  hasFetched.current = true;
  
	  showLoading();
	  if (templateId) {
		setLoader(true);
		getTemplatePageDraftList({ templateId, pagination, selectedTab });
	  }
	}
  
	fetchData();
  }, [templateId, selectedTab]);

  useEffect(() => {
	async function fetchData() {
	if(templateId && templatePagesDrafts?.totalElements>=0)
		{
			setLoader(false)
			hideLoading();
		}else{
			if(templateId){
				setLoader(true);
				showLoading();
				setAddEditPages(false);
			}
		}
	}
	fetchData();
  },[templatePagesDrafts]);

  const searchOnClick =debounce((e) => {
	const query = e.target.value;
	setQuery(query); 
	setPagination({current:1,pageSize:10})
	setLoader(true);
	getTemplatePageDraftList({templateId,query,pagination});
},500);

    const toggle = (checked,templatePagesDraft) =>{
		if(checked){
			templatePagesDraft['status'] ='ACTIVE';
		}else{
			templatePagesDraft['status'] ='INACTIVE';
		}
		templatePagesDraft["appId"]= appId;
		setLoader(true);
		if(selectedTab=="drafts"){
			updateTemplatePageDraft({"values": templatePagesDraft, "publish":undefined,"status":"status" });
		}else{
			updateTemplatePageDraft({"values": templatePagesDraft, "publish": "publish","status":"status" });
		}
	}
	const  onBoardDelete = templatePageDraft=> {
        showLoading();
		Modal.confirm({
			title: `Do you want to delete ${templatePageDraft.pageName} page?`,
			icon: <ExclamationCircleOutlined />,
			okText: 'Yes',
			cancelText: 'Cancel',
			onOk() {
				setLoader(true);
				deleteTemplatePageDraft({templatePageDraft,selectedTab});
			},
		});
	}
    const onEdit = (templatePagesDraftData)=> {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		  });
		localStorage.setItem("templatePagesDraftData",JSON.stringify(templatePagesDraftData));
        setAddEditPages(true);
		hideLoading();
     }
    const cancel=()=>{
        setAddEditPages(false);
    }

		const preview =(data)=>{
			const json = JSON.parse(data?.dataForPreview);
			localStorage.setItem("code",data?.content.replace(/\{\{(\w+)\}\}/g,
			(_, key) => json[key] || ""));
			window.open(`${PATH_VARIABLE}${AUTH_PREFIX_PATH}/templates/${templateId}/pages/preview`, "_blank");
		  }
		  
		  const handleOk = () => {
			setIsModalOpen(false);
			};
		  
		  const handleCancel = () => {
		  setIsModalOpen(false);
		  };
		
		return (
			<> 
      <Modal
        title={t("impaqx.adminApp.preview")}
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
		cancelButtonProps={{ style: { display: 'none' } }} // Hides the Cancel button
      >
        <div dangerouslySetInnerHTML={{ __html: replacedHTML }} />
      </Modal>
			{/* <motion.div 
				initial={{ opacity: 0, marginBottom: 0 }} 
				animate={{ 
					opacity: showMessage ? 1 : 0,
					marginBottom: showMessage ? 20 : 0 
				}}> 
				</motion.div> */}
			{(!loader && templatePagesDrafts.totalElements>0 && templateId) || query!==undefined?<>
			 {/* {!addEditPagesValue? <div className='text-right d-flex justify-content-end'>
				<Button type="primary" className="ant-btn ant-btn-primary ant-btn-sm" onClick={()=>{onAdd()}} size="small">
					<span>{t("impaqx.adminApp.add")}</span>
				</Button></div>:null} */}
			<div className="chat-menu-toolbar" style={{'paddingBottom': '20px','width':'17%'}}>
				<Input 
					placeholder="Search" 
					onChange={searchOnClick}
					prefix={
						<SearchOutlined className="font-size-lg mr-2"/>
					}
				/>
			</div></>:null}
            {addEditPagesValue? <AddTemplatePageDraft selectedTab={selectedTab} templatePagesDraft={localStorage.getItem("templatePagesDraftData")} param={param} addEditPagesValue={addEditPagesValue}  cancel={cancel} switchTabs={switchTabs}/>:null}
			{/* {(templateId && !loading && templatePagesDrafts.totalElements>=0) || query!==undefined?<Card bodyStyle={{'padding': '0px'}}>
				<div className="table-responsive"> */}
			<Row>{loader?<GridLoader loading={loader} rowCount={2} columnCount={6} />:
			<ListGridView  templatePagesDrafts={templatePagesDrafts?.content} edit={onEdit} preview={preview} deletePage={onBoardDelete} toggle={toggle}/>}
			</Row>
			{/* </div>
			</Card>:<>{loading?<GridLoader loading={loading} rowCount={2} columnCount={6} />:null}</>} */}
			{templateId==null || templateId==""|| selectedTemplate==null || selectedTemplate==""?<><Row justify="center" gutter={24}>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row">
					<Card style={{textAlign: "center"}}>
				<Empty
			image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
			imageStyle={{
			height: 60,
			}}
			description={
			<span>
				{t("impaqx.adminApp.noTemplateSelect")} {t("impaqx.adminApp.pleaseSelectTemplate")}
						</span>
				}
			>
					<div className="text-right d-flex justify-content-center">
				</div>
			</Empty></Card></Col></Row></>:<>{templatePagesDrafts?.totalElements<1 && query===undefined && templateId? 
			<Row justify="center" gutter={24}>
					<Col xs={24} sm={24} md={12} lg={12} className="gutter-row">
					<Card style={{textAlign: "center"}}>
				<Empty
			image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
			imageStyle={{
			height: 60,
			}}
			description={
			<span>
				{t("impaqx.adminApp.noDataAvailable")}
						</span>
				}
			>
					<div className="text-right d-flex justify-content-center">
				{/* <Button type="primary"  onClick={()=>{onAdd()}}>{t("impaqx.adminApp.createNow")}</Button> */}
				</div>
			</Empty></Card></Col></Row>:null}</>}
			</>
		)
	
}

const mapStateToProps = ({templatePage}) => {
	const { addEditPagesValue,loading,templatePagesDrafts,selectedTab} = templatePage;
	return {
		addEditPagesValue,
		loading,
		templatePagesDrafts,
		selectedTab
	}
};
export default connect(
  mapStateToProps,
  {  getTemplatePageDraftList,deleteTemplatePageDraft,setAddEditPages,showLoading,hideLoading,updateTemplatePageDraft}
)(TemplatePageList);
